import { useSelector } from 'react-redux';
import { ChartTooltip } from './ChartTooltip.jsx';

import * as S from './ChartDay.styled';

export const ChartDayMetrics = ({
  day,
  dayData = {},
  tooltipPlacement,
  height,
  maxValues,
  metrics,
  colors,
  selectedMetricsSelector,
  currentEventTitle,
}) => {
  const coords = {};
  for (const [key, value] of Object.entries(dayData)) {
    coords[key] = maxValues[key] ? (height / maxValues[key]) * value : 0;
  }
  const [slice, key] = selectedMetricsSelector.split('.');
  const selectedMetrics = useSelector((state) => state[slice]?.[key]);

  const styles = {};

  metrics.forEach((metric) => {
    styles[metric] = {
      display: selectedMetrics[metric] ? 'block' : 'none',
      bottom: `${Math.round(coords[metric])}px`,
      borderColor: colors[metric].main,
      backgroundColor: colors[metric].background,
    };
  });

  const isTooltipVisible = Object.values(selectedMetrics).some((item) => item);

  return (
    <>
      {metrics.map((metric) => (
        <S.Point key={metric} style={styles[metric]} />
      ))}
      {!!Object.keys(dayData).length && isTooltipVisible && (
        <S.TooltipWrap tooltipPlacement={tooltipPlacement}>
          <ChartTooltip
            day={day}
            dayData={dayData}
            metrics={metrics}
            colors={colors}
            selectedMetrics={selectedMetrics}
            tooltipPlacement={tooltipPlacement}
            currentEventTitle={currentEventTitle}
          />
        </S.TooltipWrap>
      )}
    </>
  );
};
